
  export function isValidUKPhone(phone) {
    const cleaned = phone.replace(/\s+/g, "");
    return /^(?:\+44|0044|0)(?:7\d{9}|1\d{9}|2\d{9}|3\d{9}|5\d{9}|8\d{9}|9\d{9})$/.test(
      cleaned
    );
  }
  export   function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }